import {Heading} from 'platform/foundation';
import styled from 'styled-components';
import {match, Pattern} from 'ts-pattern';

import type {AdvertisementPreviewPlatform} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {EMPTY_PLACEHOLDER} from '@dms/shared';

// Allow wrapping immediately after a middle dot.
const MIDDLE_DOT = '·';
const ZERO_WIDTH_SPACE = '​';

export function AdvertisementPreviewTitleExtension(props: {
  rawValue: string | null;
  selectedPlatform?: AdvertisementPreviewPlatform;
  isDefaultLanguage: boolean;
}) {
  const value =
    props.isDefaultLanguage && props.selectedPlatform
      ? props.selectedPlatform.titleExtension.value
      : props.rawValue;

  return (
    <TitleExtensionWrap>
      {match({value, isDefaultLanguage: props.isDefaultLanguage})
        .with({value: null, isDefaultLanguage: true}, () => (
          <Heading size={3} alternative color="secondary" headingLevel={2}>
            {EMPTY_PLACEHOLDER}
          </Heading>
        ))
        .with({value: null, isDefaultLanguage: false}, () => (
          <Heading size={3} alternative color="secondary" headingLevel={2}>
            {i18n.t('page.advertisement.preview.notTranslated')}
          </Heading>
        ))
        .with({value: Pattern.string}, ({value}) => (
          <Heading size={3} alternative color="secondary" headingLevel={2}>
            {value.replaceAll(MIDDLE_DOT, `${MIDDLE_DOT}${ZERO_WIDTH_SPACE}`)}
          </Heading>
        ))
        .exhaustive()}
    </TitleExtensionWrap>
  );
}

const TitleExtensionWrap = styled.div`
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
`;
